import React, { useState, useEffect } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  SelectField,
  DateField,
  useListContext,
  useVersion,
  Datagrid,
} from 'react-admin';

import { Card, CardContent } from '@material-ui/core';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import {
  stringify,
  formatMoeda,
  formatPeso,
  disablePeso,
  getEstoqueLabel,
} from '../../utils';
import { PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR } from '../../utils/dadosTelas';
import { choicesOrigem, choicesTipo } from './choices';
import Filter from './Filter';
import PesoField from './PesoField';
import QuantidadeField from './QuantidadeField';
import SaldoField from './SaldoField';
import UnidadesField from './UnidadesField';

function getColor(valor) {
  if (valor < 0)
    return {
      background: '#ffcccc',
      color: '#e60000',
    };

  return {
    background: '#ccffcd',
    color: '#00e604',
  };
}

const CardTotal = ({
  label,
  valor,
  style = {},
  isPreco = true,
  isColor = false,
}) => {
  const { background, color } = getColor(valor);
  return (
    <Card
      style={{
        borderRadius: '20px',
        cursor: 'pointer',
        flex: 1,
        backgroundColor: isColor ? background : 'white',
        color: isColor ? color : 'black',
        /* maxWidth: '33%',
        minWidth: '20%', */
        width: '50%',
        ...style,
      }}
    >
      <CardContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            height: '100%',
            alignItems: 'center',
          }}
        >
          <div>
            <div
              style={{
                fontSize: '20px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                /* color: 'black', */
              }}
            >
              {label}
            </div>
            <div
              style={{
                fontSize: '30px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {isPreco ? `${formatMoeda(valor)}` : valor}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

function SectionTotal() {
  const listContext = useListContext();
  const version = useVersion();
  const { ids, filterValues, setFilters, displayedFilters, data } = listContext;
  const [dados, setDados] = useState({
    unidades: '',
    peso: '',
    quantidade: '',
    produto: null,
  });
  const [loading, setLoading] = useState(false);

  async function getDados() {
    if (filterValues.produto_id) {
      setLoading(true);
      const dados = await api.get(
        `/totais-movimentacoes-estoque?${stringify({
          filter: JSON.stringify({
            periodo: filterValues.periodo,
            produto_id: filterValues.produto_id,
            tipo: filterValues.tipo,
            origem: filterValues.origem,
          }),
        })}`,
      );
      setDados({
        unidades: dados.data.unidades ? `${dados.data.unidades} Un` : '-',
        peso: disablePeso(dados.data.produto)
          ? formatPeso(dados.data.peso)
          : '-',
        quantidade: getEstoqueLabel(
          dados.data.produto,
          dados.data.unidades,
          dados.data.peso,
        ),
        produto: dados.data.produto,
      });
      setLoading(false);
    } else {
      setDados({
        unidades: '',
        peso: '',
        quantidade: '',
        produto: null,
      });
    }
  }

  useEffect(() => {
    getDados();
  }, [
    filterValues.periodo,
    filterValues.produto_id,
    filterValues.tipo,
    filterValues.origem,
    version,
  ]);

  return (
    <>
      {dados.produto ? (
        <div
          style={{
            margin: '10px 0',
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
          }}
        >
          <CardTotal
            label="Total Unidades"
            valor={dados.unidades}
            isPreco={false}
          />
          <CardTotal label="Total Peso" valor={dados.peso} isPreco={false} />
          <CardTotal
            label="Total Quantidade"
            valor={dados.quantidade}
            isPreco={false}
          />
        </div>
      ) : null}
    </>
  );
}

const MyList = ({ ...props }) => (
  <>
    <ListToolbar
      filters={props.filters}
      actions={<ActionsList {...props} />}
      {...props}
    />
    <Card style={{ borderRadius: '20px' }} {...props}>
      <SectionTotal />
      <Datagrid {...props}>
        <Textofield source="produto.nome" label="Produto2" sortable={false} />
        <SelectField
          sortable={false}
          source="tipo"
          label="Tipo"
          choices={choicesTipo}
        />
        <SelectField
          sortable={false}
          source="origem"
          label="Origem"
          choices={choicesOrigem}
        />
        <TextField source="origem_id" label="Origem_Id" sortable={false} />
        <DateField source="created_at" label="Data" showTime />
        <QuantidadeField
          source="quantidade"
          label="Quantidade"
          sortable={false}
        />
        <UnidadesField source="unidades" label="Unidades" sortable={false} />
        <PesoField source="peso" label="Peso" sortable={false} />
        <SaldoField
          source="saldo_unidades_apos"
          label="Saldo após"
          sortable={false}
        />
      </Datagrid>
      <TransacoesPagination />
    </Card>
  </>
);

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Movimentação de Estoque22"
    />
  </ProtegerPagina>
);

export default List2;
